import React from 'react';

const PrintRow = ({title, value, plate = false, place = false}) => {
    return (
        <tr>
            <th className="text-left border-0! border-solid! border-[#dee2e6]! w-45 pl-1.25">
                {title}
            </th>
            <td className={`border-0! border-solid! border-[#dee2e6]! w-45 pl-1.25 ${plate ? 'font-bold' : ''}`}>
                {
                    place ?
                        <span dangerouslySetInnerHTML={{ __html: value }} />
                        :
                        value
                }

            </td>
        </tr>
    );
};

export default PrintRow;